import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';

interface RadioButtonGroupProps {
    options: { id: string; value: string; label: string; checked: boolean }[];
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({ options, onChange }) => {
    return (
        <Row className="mt-4 text-start">
            {options.map((option) => (
                <Col md={2} key={option.id}>
                    <Form.Check
                        type="radio"
                        id={option.id}
                        label={option.label}
                        value={option.value}
                        checked={option.checked}
                        onChange={onChange}
                        className="small"
                    />
                </Col>
            ))}
        </Row>
    );
};

export default RadioButtonGroup;
